import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SeeMoreInfoModal from "@tKgpco/Components/SeeMoreInfoModal";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
    isAuthenticated: state.context.session?.isAuthenticated && !state.context.session?.isGuest,
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductLeadTimeStyles {
    seeLeadTimeLink?: LinkPresentationProps;
    seeLeadTimeLinkGridItem?: GridItemProps;
    tooltipText?: InjectableCss;
}

export const productLeadTimeStyles: ProductLeadTimeStyles = {
    seeLeadTimeLink: {
        css: css`
            & :hover .tooltipText {
                visibility: visible;
            }
        `,
    },
    seeLeadTimeLinkGridItem: {
        width: 5,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: flex-end;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
            > span {
                background: #e1e7ed;
                padding: 3px 4px;
                border-radius: 4px;
                width: 85px;
                > span {
                    color: #353432 !important;
                    font-size: ${TYPOGRAPHY.size.vTiny};
                    width: 85px;
                    text-align: center;
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 10px !important;
                    }
                }
            }
        `,
    },
    tooltipText: {
        css: css`
            visibility: hidden;
            width: auto;
            background-color: black;
            color: #fff;
            text-align: center;
            border-radius: 6px;
            padding: 5px 6px;
            opacity: 0.8;
            position: absolute;
            z-index: 1;
            margin-top: 10px;
        `,
    },
};

const styles = productLeadTimeStyles;

const ProductDisplayLeadTime = ({ productContext, isAuthenticated }: Props) => {
    const { product, productInfo } = productContext;
    let leadtime = "";
    if (productInfo?.pricing?.additionalResults && Object.keys(productInfo?.pricing?.additionalResults).length > 0) {
        leadtime = productInfo?.pricing?.additionalResults?.leadTime;
    }
    if (
        !product ||
        !leadtime ||
        leadtime === "" ||
        productInfo?.pricing?.additionalResults?.showContactUsMessage?.toLowerCase() === "true"
    ) {
        return null;
    }
    if (!isAuthenticated) {
        return null;
    }
    return (
        <>
            <GridItem {...styles.seeLeadTimeLinkGridItem}>
                <Link {...styles.seeLeadTimeLink} data-test-selector="seeLeadTimeLink">
                    {translate("See Lead Time")}
                    <StyledWrapper className="tooltipText" {...styles.tooltipText}>{`${leadtime} days`}</StyledWrapper>
                </Link>
            </GridItem>
            {isAuthenticated && <SeeMoreInfoModal product={product} />}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDisplayLeadTime)),
    definition: {
        group: "Products",
        displayName: "Product Lead Time",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
